import {parseNumber} from '../../utils/numerals/parseNumber';
import {trigger} from '../../utils/events/trigger';
import {monthsToYears} from '../../utils/numerals/monthsToYears';
import {years} from '../../utils/numerals/years';
import {spaceNumber} from '../../utils/numerals/spaceNumber';
import {pluralNumber} from '../../utils/numerals/pluralNumber';

export const initRangeOne = () => {
	const elements = document.querySelectorAll( 'div.cds2-range-one' );

	if ( !elements.length )
	{
		return;
	}

	let rangeOneHandler = null;
	let rangeOneInput = null;
	let rangeOneInputTimeout = 0;
	let savedValue = '';

	const preventDefault = ( evt ) => {
		evt.preventDefault();
	};

	const disableScroll = () => {
		document.body.addEventListener( 'touchmove', preventDefault, {passive: false} );
	};

	const enableScroll = () => {
		document.body.removeEventListener( 'touchmove', preventDefault );
	};

	const initButton = ( evt ) => {
		document.body.classList.add( 'range-one-dragging' );
		rangeOneHandler = evt.target;

		disableScroll();
	};

	const updateRangeOne = ( argument ) => {
		let container = null;
		const dotPosition = 0;
		const isFloat = false;

		if ( typeof argument === 'number' && rangeOneHandler !== null )
		{
			container = rangeOneHandler.closest( 'div.cds2-range-one' );
		}
		else if ( rangeOneInput === null )
		{
			container = argument.closest( 'div.cds2-range-one' );
		}
		else
		{
			container = rangeOneInput.closest( 'div.cds2-range-one' );
		}

		if ( container === null )
		{
			return;
		}

		const form = container.closest( 'form' );
		const userValueMin = parseNumber( container.querySelector( 'input.user-value' ).getAttribute( 'min' ), isFloat );
		const min = 0;
		const max = parseNumber( container.querySelector( 'input.user-value' ).getAttribute( 'max' ), isFloat ) - userValueMin;
		const dataType = container.dataset.type;
		let uValue = null;

		if ( typeof argument === 'number' && rangeOneHandler !== null )
		{
			uValue = ( max - min ) / 100 * argument;
		}
		else if ( rangeOneInput === null )
		{
			uValue = parseNumber( container.querySelector( 'input.user-value' ).value, isFloat ) - userValueMin;
		}
		else
		{
			if ( dataType === 'time' )
			{
				uValue = monthsToYears( argument.match( /\d+/gu ) );
			}
			else if ( Number( argument.replace( /[^0-9]+/gu, '' ) ) )
			{
				uValue = Number( argument.replace( /[^0-9]+/gu, '' ) ) - userValueMin;
			}
			else
			{
				uValue = 0;
			}

			rangeOneInput = null;
		}

		if ( isNaN( uValue ) || uValue < min )
		{
			uValue = min;
		}
		else if ( uValue > max )
		{
			uValue = max;
		}

		uValue = parseNumber( uValue, isFloat );

		const vValue = uValue * 100 / ( max - min );

		container.querySelector( 'button.handle' ).style.left = `${vValue}%`;
		container.querySelector( 'span.range' ).style.width = `${vValue}%`;

		const inputUserValueVal = ( uValue + userValueMin ).toFixed( dotPosition );

		const userValue = container.querySelector( 'input.user-value' );

		if ( dataType === 'time' )
		{
			userValue.setAttribute( 'data-value', inputUserValueVal );
			userValue.value = monthsToYears( inputUserValueVal );
		}
		else if ( dataType === 'year' )
		{
			userValue.setAttribute( 'data-value', inputUserValueVal );
			userValue.value = years( inputUserValueVal );
		}
		else if ( dataType === 'install_payment' )
		{
			const percents = Math.round( inputUserValueVal / container.dataset.fromValue * 100 );
			
			container.dataset.percent = `${percents} %`;
			userValue.value = `${spaceNumber( inputUserValueVal )} ₽`;
			userValue.placeholder = `${spaceNumber( inputUserValueVal )} ₽`;

			if ( form.dataset.coefficient )
			{
				const coefficient = Number( form.dataset.coefficient );
				const resultPrice = container.dataset.fromValue * coefficient;
				const requestedPayment = resultPrice - Math.round( resultPrice / 100 * percents ) < 12000000 ? Math.round( resultPrice / 100 * percents ) : resultPrice - 12000000;

				if ( argument.tagName && argument.tagName.toLowerCase() === 'div' )
				{
					userValue.value = `${spaceNumber( requestedPayment )} ₽`;
					userValue.placeholder = `${spaceNumber( requestedPayment )} ₽`;
					rangeOneInput = userValue;
					updateRangeOne( userValue.value );
				}
				else
				{
					if ( Number( document.querySelector( 'ul.programs-cards.current li.promo span.min-payment' ).dataset.minPayment ) > Number( inputUserValueVal ) )
					{
						document.querySelector( 'ul.programs-cards.current li.promo' ).classList.add( 'disabled' );
					}
					else
					{
						document.querySelector( 'ul.programs-cards.current li.promo' ).classList.remove( 'disabled' );
					}
				}
			}
		}
		else if ( dataType === 'price' )
		{
			userValue.value = `${spaceNumber( inputUserValueVal )} ₽`;
			userValue.placeholder = `${spaceNumber( inputUserValueVal )} ₽`;
			
			if ( form )
			{
				const installPaymentRange = form.querySelector( '[data-type="install_payment"]' );
				const installPaymentPercentMin = installPaymentRange.dataset.min;
				const installPaymentPercentMax = installPaymentRange.dataset.max;
				const installPaymentPercent = installPaymentRange.dataset.percent.replace( ' %', '' );
				let installPayment = 0;

				installPaymentRange.dataset.fromValue = inputUserValueVal;
				installPaymentRange.querySelector( 'input.user-value' ).min = inputUserValueVal - Math.round( inputUserValueVal / 100 * installPaymentPercentMin ) < 12000000 ? Math.round( inputUserValueVal / 100 * installPaymentPercentMin ) : inputUserValueVal - 12000000;
				installPaymentRange.querySelector( 'input.user-value' ).max = inputUserValueVal - Math.round( inputUserValueVal / 100 * installPaymentPercentMax ) < 12000000 ? Math.round( inputUserValueVal / 100 * installPaymentPercentMax ) : inputUserValueVal - 12000000;

				if ( form.dataset.coefficient )
				{
					const coefficient = Number( form.dataset.coefficient );
					const resultPrice = Math.round( inputUserValueVal * coefficient );

					installPayment = resultPrice - Math.round( resultPrice / 100 * installPaymentPercentMin ) < 12000000 ? Math.round( resultPrice / 100 * installPaymentPercentMin ) : resultPrice - 12000000;
					document.querySelector( 'ul.programs-cards.current li.promo span.min-payment' ).innerHTML = `от ${spaceNumber( installPayment )} ₽`;
					document.querySelector( 'ul.programs-cards.current li.promo span.min-payment' ).dataset.minPayment = Math.round( installPayment );

					if ( installPaymentRange.querySelector( 'input.user-value' ).max < installPayment )
					{
						document.querySelector( 'ul.programs-cards.current li.promo' ).classList.add( 'disabled' );
						installPayment = installPaymentRange.querySelector( 'input.user-value' ).max;
					}
					else
					{
						document.querySelector( 'ul.programs-cards.current li.promo' ).classList.remove( 'disabled' );
					}
				}
				else
				{
					installPayment = inputUserValueVal - Math.round( inputUserValueVal / 100 * installPaymentPercent ) < 12000000 ? Math.round( inputUserValueVal / 100 * installPaymentPercent ) : inputUserValueVal - 12000000;
				}

				installPaymentRange.querySelector( 'input.user-value' ).value = `${spaceNumber( installPayment )} ₽`;
				installPaymentRange.querySelector( 'input.user-value' ).placeholder = `${spaceNumber( installPayment )} ₽`;

				if ( form.dataset.coefficient )
				{
					const rangeLocation = ( Math.round( installPayment / inputUserValueVal * 100 ) - installPaymentPercentMin ) / ( installPaymentPercentMax - installPaymentPercentMin ) * 100;

					installPaymentRange.querySelector( 'span.range' ).style.width = `${rangeLocation}%`;
					installPaymentRange.querySelector( 'button.handle' ).style.left = `${rangeLocation}%`;
				}

				if ( form.querySelector( '[data-type="year"]' ) )
				{
					const yearRange = form.querySelector( '[data-type="year"]' );
					const yearMin = yearRange.dataset.min;
					const yearMax = yearRange.dataset.max;
					const yearUserValue = Math.round( yearMax / 100 * Number( yearRange.querySelector( 'span.range' ).style.width.replace( '%', '' ) ) );

					yearRange.querySelector( 'input.user-value' ).min = yearMin;
					yearRange.querySelector( 'input.user-value' ).max = yearMax;
					yearRange.querySelector( 'input.user-value' ).value = `${yearUserValue} ${pluralNumber( yearUserValue, 'год', 'года', 'лет' )}`;
					yearRange.querySelector( 'input.user-value' ).placeholder = `${yearUserValue} ${pluralNumber( yearUserValue, 'год', 'года', 'лет' )}`;
					trigger( yearRange.querySelector( 'input.user-value' ), 'change' );
				}
			}
		}
		else
		{
			userValue.value = inputUserValueVal;
		}
	};

	const moveButton = ( x ) => {
		if ( !document.body.classList.contains( 'range-one-dragging' ) )
		{
			return;
		}

		const position = rangeOneHandler.closest( 'div.cds2-range-one' ).querySelector( 'div.controls' ).getBoundingClientRect().left;
		const width = rangeOneHandler.closest( 'div.cds2-range-one' ).querySelector( 'div.controls' ).offsetWidth;
		let newPosition = ( x - position ) / width * 100;

		if ( newPosition < 0 )
		{
			newPosition = 0;
		}
		else if ( newPosition > 100 )
		{
			newPosition = 100;
		}
		
		updateRangeOne( newPosition );
	};

	const releaseButton = () => {
		if ( !document.body.classList.contains( 'range-one-dragging' ) )
		{
			return;
		}

		enableScroll();

		document.body.classList.remove( 'range-one-dragging' );
		trigger( rangeOneHandler.closest( 'div.cds2-range-one' ).querySelector( 'input.user-value' ), 'change' );
		rangeOneHandler = null;
	};

	const clearInput = ( evt ) => {
		if ( !evt.target.hasAttribute( 'readonly' ) )
		{
			savedValue = evt.target.value;
			evt.target.value = '';
		}
	};

	const returnValue = ( evt ) => {
		if ( evt.target.value === '' )
		{
			evt.target.value = savedValue;
		}
	};

	[...elements].forEach( ( elem ) => {
		elem.querySelector( 'input.user-value' ).value = elem.querySelector( 'input.user-value' ).getAttribute( 'value' );
		updateRangeOne( elem );

		elem.querySelector( 'input' ).addEventListener( 'keydown', ( evt ) => {
			if ( typeof evt.key === 'string' && !/\d|\s/u.test( evt.key ) && evt.key !== 'Backspace' && evt.key !== 'Delete' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowRight' )
			{
				evt.preventDefault();

				return;
			}

			clearTimeout( rangeOneInputTimeout );
			rangeOneInput = evt.target;

			rangeOneInputTimeout = setTimeout( () => {
				updateRangeOne( rangeOneInput.value );
			}, 2000 );
		} );
		
		elem.querySelector( 'input.user-value' ).addEventListener( 'mousedown', clearInput );
		elem.querySelector( 'input.user-value' ).addEventListener( 'focusout', returnValue );
		elem.querySelector( 'button.handle' ).addEventListener( 'mousedown', initButton );
		elem.querySelector( 'button.handle' ).addEventListener( 'touchstart', initButton, {passive: true} );
	} );

	Array.from( document.querySelectorAll( 'button[type="reset"]' ) ).forEach( ( it ) => {
		const form = document.querySelector( `form#${it.dataset.for}` );

		it.addEventListener( 'click', ( evt ) => {
			evt.preventDefault();
			form.reset();
			
			[...elements].forEach( ( elem ) => {
				updateRangeOne( elem );
				trigger( elem.querySelector( 'input.user-value' ), 'change' );
			} );

			form.classList.remove( 'user-changed' );
		} );
	} );

	document.body.addEventListener( 'mousemove', ( evt ) => {
		const coord = evt.pageX;

		moveButton( coord );
	} );

	document.body.addEventListener( 'touchmove', ( evt ) => {
		const coord = evt.touches[0].pageX;

		moveButton( coord );
	} );

	document.body.addEventListener( 'mousedown', ( evt ) => {
		const coord = evt.pageX;

		moveButton( coord );
	} );

	document.body.addEventListener( 'mouseup', releaseButton );
	document.body.addEventListener( 'touchend', releaseButton );
};
